module.exports = __webpack_public_path__ + "img/user-20.c1b206f6.svg";